
export const ASSET_BASE_URL = process.env.ASSET_BASE_URL

export const NODE_ENV = process.env.NODE_ENV

export const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY



// WEBPACK FOOTER //
// ./config.js